import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const invitationValidationSchema = yupResolver(
  yup.object().shape({
    email: yup.string().email().max(320).required(),
    role: yup.string().required(),
    facilityId: yup.string().required(),
    sponsorId: yup.string().required(),
  })
);
